import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 text-white pt-16 pb-8 relative"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-sky-500 to-blue-600 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-lg">C</span>
              </div>
              <span className="font-heading text-xl font-bold">
                Cozy Nests
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Professional pet grooming services in New York City. We treat every pet like family.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading font-bold text-lg">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" />
                <span className="text-sm">
                  20 E 22nd St #4699<br />New York, NY 10165
                </span>
              </li>
              <li>
                <a
                  href="tel:+18888801344"
                  data-testid="footer-phone"
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors"
                >
                  <Phone className="w-5 h-5 text-sky-400" />
                  <span className="text-sm">+1-888-8801-344</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:bookings@cozynests.store"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors"
                >
                  <Mail className="w-5 h-5 text-sky-400" />
                  <span className="text-sm">bookings@cozynests.store</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div className="space-y-4">
            <h4 className="font-heading font-bold text-lg">Business Hours</h4>
            <div className="flex items-start gap-3 text-slate-400">
              <Clock className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" />
              <div className="text-sm space-y-1">
                <p>Monday - Saturday</p>
                <p className="text-white font-medium">9:00 AM - 6:00 PM</p>
                <p className="mt-2">Sunday</p>
                <p className="text-white font-medium">Closed</p>
              </div>
            </div>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="font-heading font-bold text-lg">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy"
                  className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms"
                  className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation"
                  data-testid="footer-cancellation"
                  className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                >
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div
          data-testid="footer-disclaimer"
          className="border-t border-slate-800 pt-8 mb-8"
        >
          <p className="text-slate-500 text-sm text-center">
            Service pricing varies depending on breed, size, and specific grooming needs. A transparent quote is provided before service.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8">
          <p className="text-slate-500 text-sm text-center">
            © {currentYear} Cozy Nests. All rights reserved. | 20 E 22nd St #4699, New York, NY 10165
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
